import { render, staticRenderFns } from "./MegaMenuColumn.vue?vue&type=template&id=36f82c03&scoped=true&"
import script from "./MegaMenuColumn.vue?vue&type=script&lang=js&"
export * from "./MegaMenuColumn.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenuColumn.vue?vue&type=style&index=0&id=36f82c03&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f82c03",
  null
  
)

export default component.exports